import React from "react";
import PropTypes from "prop-types";
import { Row, Col } from "antd";
import { useTranslation } from "react-i18next";
import ButtonField from "../../../../../common/htmlComponents/ButtonField";

const ConfirmAlertPrevious = ({ handleCancelc3, handlePreviousTabChange }) => {
  const { t } = useTranslation();

  const backToList = () => {
    handleCancelc3();
  };
  const handlePreviousPage = () => {
    // const { currenttab } = currentTab;
    // let showTabName = componentArr[currenttab + 1];
    // hideComponent(showTabName);
    handlePreviousTabChange();
    handleCancelc3();
  };
  return (
    <>
      <p>{t("model_description_message")}</p>
      <Row gutter={[15]} className="bottomButtons">
        <Col xs={12} align="center">
          <ButtonField
            type="primary"
            htmlType=""
            // loading={btnLoading}
            label={t("button_back")}
            onClick={handlePreviousPage}
          />
        </Col>
        <Col xs={12} align="center">
          <ButtonField
            type="primary"
            htmlType=""
            // loading={btnLoading}
            label={t("button_save")}
            onClick={backToList}
          />
        </Col>
      </Row>
    </>
  );
};
ConfirmAlertPrevious.propTypes = {
  handleCancelc3: PropTypes.func,
  handlePreviousTabChange: PropTypes.func,
};

export default ConfirmAlertPrevious;
